import { Divider, Grid } from "@material-ui/core";
import React from "react";
import { formatCep } from "../../../../../../../../utils/formatters";
import DataCell from "../../cells/data";

const filterJoin = (array, character) => {
  return array.filter((val) => val).join(character);
};

const buildAdressLines = (data) => {
  const {
    tipoLogradouro,
    logradouro,
    numero,
    complemento,
    bairro,
    cidade,
    uf,
    cep,
  } = data;

  const street = filterJoin([tipoLogradouro, logradouro], ". ");
  const number = filterJoin([numero || "S/N", complemento], " - ");

  return [
    `${street}, ${number}`,
    `${filterJoin([bairro, cidade], " - ")}/${uf}`,
    formatCep(cep),
  ].filter((val) => val);
};

const AddressData = ({ data }) =>
  data && data.length > 0 ? (
    <>
      <Divider className="mt-20 mb-20 w-100" />

      <Grid spacing={3} container>
        <div
          className="qd-data-cell-label w-100"
          style={{ paddingLeft: "12px" }}
        >
          {data.length === 1 ? "Endereço" : "Endereços"}
        </div>

        {data.map((value) => (
          <DataCell
            key={`${value.latitude}-${value.longitude}`}
            xs={12}
            md={6}
            value={buildAdressLines(value).map((line) => (
              <div key={line}>{line}</div>
            ))}
          />
        ))}
      </Grid>
    </>
  ) : null;

export default AddressData;
